import { Model } from "./ModelList";
import { Button } from "./ui/button";
import { ScrollArea } from "./ui/scroll-area";

 

import { useEffect, useState, type SVGProps } from "react";
import { useNavigate, useParams } from "react-router-dom";

export interface Category {
  name:string
  icon:any
  code:string
}

interface CategorySidebarProps {
  selectedCategory: Category;
  onCategorySelect: (category: Category) => void;
  categories: Category[]
}

export function CategorySidebar({ selectedCategory, onCategorySelect,categories }: CategorySidebarProps) {
    const navigate = useNavigate();
    const { model } = useParams<{ model?: string }>();

  const handleCategoryClick = (category: typeof categories[number]) => {
    onCategorySelect(category);
    if (model) {
      navigate(`/${category.code}/model/${model}`);
    } else {
      navigate(`/${category.code}`);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-4 border border-blue-100">
      <h2 className="text-xl font-bold mb-4 text-blue-900"></h2>
      
        <div className="space-y-2">
          {categories.map((category) => {
            const Icon = category.icon;
            const isSelected = selectedCategory.code === category.code;
            return (
              <Button
                key={category.name}
                variant={isSelected ? "default" : "ghost"}
                className={`text-lg w-full h-full justify-start ${
                  isSelected 
                    ? "bg-gradient-to-br from-blue-950 to-blue-800 text-white hover:bg-blue-700" 
                    : "hover:bg-blue-50 text-gray-700"
                }`}
                onClick={() => handleCategoryClick(category)}
              >
                <Icon className={`mr-5 h-5 w-5 fill-current`} color={isSelected ? "white" : "bg-gradient-to-br from-blue-950 to-blue-800"} size={'50px'} />
                {category.name}
              </Button>
            );
          })}
        </div>
   
    </div>
  );
}
